import middlewareConfig from "./middleware-config";
import { MIDDLEWARE_ENUMS } from "./middleware-constants";

const vasBffService = (api) => {

    const getPdiData = () => {
        return api.get("/api/v1/PDI/HOME_PAGE");
    };

    const getPdiCityData = (city) => {
        return api.get(`/api/v1/PDI/CITY_PAGES?slug=${city}`);
    };

    const getOrderDetailsV2 = ({authToken, orderNumber, isNewOrder}) => {
        return api.get(`/api/v1/vas/order/${orderNumber}?isNewOrder=${isNewOrder}`, {
            headers: {
                "pvtAuthorization": `Bearer ${authToken}`
            }
        });
    };

    const getOrderListV2 = ({authToken}) => {
        return api.get("/api/v1/vas/order/list", {
            headers: {
                "pvtAuthorization": `Bearer ${authToken}`
            }
        });
    };

    const getOrderCategory = ({authToken, orderNumber}) => {
        return api.get(`/api/v1/vas/category/order/${orderNumber}`, {
            headers: {
                "pvtAuthorization": `Bearer ${authToken}`
            }
        });
    };

    return {
        getPdiData,
        getPdiCityData,
        getOrderDetailsV2,
        getOrderListV2,
        getOrderCategory
    };
};

export const VasBffService = vasBffService(middlewareConfig(MIDDLEWARE_ENUMS.VAS_BFF_SERVICE));
